import { render, staticRenderFns } from "./RouteToProButton.vue?vue&type=template&id=42410656"
import script from "./RouteToProButton.vue?vue&type=script&lang=ts"
export * from "./RouteToProButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports